import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

const RedirectToArtistSubmission = ({ action = 'apply' }) => {
  const { submissionId } = useParams();
  
  return <Navigate to={`/artist/submissions/${submissionId}/${action}`} replace />;
};

export default RedirectToArtistSubmission;
